

export enum DeploymentPrefix {
    Dev = "dev",
    Demo = "demo",
    Prod = "app",
    Custom = "custom",
    Tenant002 = "tenant002",
    Alpha = "v3.alpha"
}

/**
 * Maps a DeploymentPrefix to the corresponding CDN directory name.
 * Pre-release environments (alpha, beta, etc.) don't have their own CDN directories,
 * so they fall back to "dev".
 */
export function getCdnPrefix(prefix: DeploymentPrefix): string {
    switch (prefix) {
        case DeploymentPrefix.Alpha:
            return DeploymentPrefix.Dev;
        default:
            return prefix;
    }
}